<template>
  <div class="enterprise-network_container">
    <div
      class="enterprise-network_container_title"
    >
      Sales Target Information
    </div>
    <div class="enterprise-network_container">
      <el-row class="enterprise-network_mb-40" v-if="formData.partnerType === 'RAD'">
        <el-col :span="12">
          <div class="enterprise-network_label">Sales Target Rebate Ratio</div>
          <div class="enterprise-network_value">
            {{ getPercentage(formData.rebateCoefficient) }}
          </div>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Total Sales Target (USD)</div>
          <div class="enterprise-network_value">
            {{ formData.targetTotal ? toThousands(formData.targetTotal) : "-" }}
          </div>
        </el-col>
      </el-row>
      <el-row class="enterprise-network_mb-40">
        <el-col :span="12">
          <div class="enterprise-network_label">Quarterly Target (USD)</div>
          <div class="enterprise-network_value enterprise-network_target-1x4">
            <div class="enterprise-network_target-item">
              <div class="top">Q1</div>
              <div class="bottom">{{ formData.saleTargetQ1 || "-" }}</div>
            </div>
            <div class="enterprise-network_target-item">
              <div class="top">Q2</div>
              <div class="bottom">{{ formData.saleTargetQ2 || "-" }}</div>
            </div>
            <div class="enterprise-network_target-item">
              <div class="top">Q3</div>
              <div class="bottom">{{ formData.saleTargetQ3 || "-" }}</div>
            </div>
            <div class="enterprise-network_target-item">
              <div class="top">Q4</div>
              <div class="bottom">{{ formData.saleTargetQ4 || "-" }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {toThousands} from "../../../../../../utils";
import {getNum} from "../../../../../../utils/upload";
import Big from "big.js";

export default {
  name: "enterpriseNetworkTargetInformationDetail",
  methods: {
    toThousands,
    getPercentage(num) {
      if (!num && num !==0) {
        return '-'
      }
      return Big(getNum(num)).times(Big(100)).toFixed(2) + '%'
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
<style scoped>
.enterprise-network_target-1x4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.enterprise-network_target-item { color: #383838; }
.enterprise-network_target-item .top {}
.enterprise-network_target-item .bottom {}
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/EBG/components/targetInformation/targetInformationDetail.vue